import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Modal from "Common/Components/Modal";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import { SearchIcon, X, CreditCard, Package } from "lucide-react";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import Swal from "sweetalert2";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import PaginationTest from "Common/Components/Paginationtest";
import ResivewastClumn from "Common/Components/ColumnData/ResivewastColumn";
const Resivewast = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [reload, setreload] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<any>();
  const token = localStorage.getItem("app_atkey");
  const [FarmerID, setFarmerID] = useState<any>();
  const [data, setdata] = useState<any>();
  const [showModalDELever, setshowModalDELever] = useState<any>(false);
  const [modealID, setmodalID] = useState<any>();
  const cropYearID = localStorage.getItem("crop_year_id");
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const [alldata, setalldata] = useState<any>();
  const [size, setsize] = useState<any>(1);
  const sortLabels: any = {
    sum_delivered_load: "جمع بار تحویلی",
    waste_quota_weight: "وزن سهمیه تفاله",
    waste_quota_price: "مبلغ سهمیه تفاله",
    waste_delivered: "تفاله تحویلی",
    waste_deposit_amount: " مبلغ واریزی تفاله",
  };
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);

  const fetchWastFromServer = async (page: number, size: number) => {
    try {
      setIsLoading(true);
      let url = `https://api.havirkesht.ir/farmers-waste-delivery/?&page=${page}&size=${size}&crop_year_id=${cropYearID}`;
      if (sortState.name) {
        if (sortState.step === 2) {
          url += `&sort_by=${sortState.name}&sort_order=desc`;
        } else {
          url += `&sort_by=${sortState.name}&sort_order=${sortState.order}`;
        }
      }
      if (searchQuery && searchQuery.trim() !== "") {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }
      console.log(url);

      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      const items = res?.data?.items || [];
      setIsLoading(false);
      setdata(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setTotalItems(res.data.total);
    } catch (error: any) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchWastFromServer(currentPage, selectedNumber);
  }, [reload, currentPage, pageSize, searchQuery, token, sortState]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const onClickDelete = (cell: any) => {
    if (cell.id) {
      Swal.fire({
        title: "آیا از لغو عملیات مطمئن هستید؟",
        text: "این عمل قابل بازگشت نیست!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله, لغو شود!",
        cancelButtonText: "انصراف",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.delete(
              `https://api.havirkesht.ir/farmers-waste-delivery/${Number(
                cell.id
              )}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
                },
              }
            );
            if (res.status === 200) {
              setreload(!reload);
              Swal.fire({
                title: "عملیات لغو شد",
                text: "لغو عملیات با موفقیت انجام شد",
                icon: "success",
              });
            } else {
              Swal.fire({
                title: "خطا در لغو عملیات",
                text: "مشکلی در حذف به وجود آمده است",
                icon: "error",
              });
            }
          } catch (error) {
            toast.error("مشکل در حذف داده");
          }
        }
      });
    } else {
      setreload(!reload);
      Swal.fire("عملیات خطا", "عملیات لغو انجام شده", "error");
    }
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;
    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید
    setPageSize(newSize);
    // فراخوانی داده‌ها با سایز و صف حه تنظیم‌شده
    fetchWastFromServer(newPage, newSize);
  };

  const deleverywaste = async (ele: any) => {
    if (ele.id == null) {
      const payload = {
        farmer_id: Number(ele.farmer_id),
        crop_year_id: Number(cropYearID),
      };
      const res: any = await axios.post(
        "https://api.havirkesht.ir/farmers-waste-delivery/",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setshowModalDELever(true);
      await setmodalID(res.data.id);
      setFarmerID(ele.farmer_id);
      setreload(!reload);
    } else {
      setshowModalDELever(true);
      setmodalID(ele.id);
    }
  };

  const handclosemodal = () => {
    setshowModalDELever(false);
    setmodalID(null);
  };

  const deleverywasteModal = async () => {
    try {
      setmodalID(null);
      setshowModalDELever(false);
      const res = await axios.post(
        `https://api.havirkesht.ir/farmers-waste-delivery/${Number(
          modealID
        )}/deliver-waste`
      );
      setshowModalDELever(false);
      if (res.status == 200) {
        Swal.fire(
          "تحویل تفاله",
          "عملیات  تحویل تفاله با موفقیت انجام شد",
          "success"
        );
        try {
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-waste-delivery-notification/${Number(
              modealID
            )}`
          );
        } catch (error) {
          console.log(error, " waste-delivery تحویل تفاله");
        }

        setreload(!reload);
        setmodalID(null);
      }
    } catch (error: any) {
      console.log(error, "ssssssssss");
      if (error.status === 400) {
        setmodalID(null);
        setshowModalDELever(false);
        return Swal.fire(
          "خطا در تحویل تفاله",
          "امکان تحویل تفاله وجود ندارد",
          "error"
        );
      } else if (error.status === 404) {
        return Swal.fire(
          "خطا در تحویل تفاله",
          "امکان انجام این عملیات وجود ندارد",
          "error"
        );
      }
    }
  };
  const PaywasteModal = async () => {
    setmodalID(null);
    setshowModalDELever(false);
    try {
      const res = await axios.post(
        `https://api.havirkesht.ir/farmers-waste-delivery/${Number(
          modealID
        )}/pay-waste`
      );
      setshowModalDELever(false);
      if (res.status == 200) {
        Swal.fire(
          "واریز هزینه تفاله",
          "عملیات واریز هزینه تفاله با موفقیت انجام شد",
          "success"
        );
        try {
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-waste-payment-notification/${Number(
              Number(modealID)
            )}`
          );
        } catch (error) {
          console.log(error, "تحویل تفاله");
        }
        setmodalID(null);
        setreload(!reload);
      }
      setmodalID(null);
      setshowModalDELever(false);
    } catch (error: any) {
      console.log(error, error.status, "ssss....");
      setmodalID(null);
      setshowModalDELever(false);

      if (error.status === 400) {
        return Swal.fire("خطا", "امکان  واریز هزینه تفاله وجود ندارد", "error");
      } else if (error.status === 404) {
        return Swal.fire("خطا", "امکان انجام این عملیات وجود ندارد", "error");
      }
    }
  };

  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = ResivewastClumn({
    onClickDelete,
    deleverywaste,
    columnName,
  });

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="مدیریت تحویل تفاله‌ها" title="پنل مدیریت" />
      <ToastContainer rtl={true} />
      <div className="card" id="paymentTable">
        <div className="card-body">
          <div className="flex flex-col md:flex-row gap-3 mb-4 items-center">
            <h6 className="text-15 grow">
              تعداد تحویل تفاله‌ها: <b>{totalItems}</b>
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جستجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <SearchIcon
                    size={15}
                    className="absolute inset-y-0 top-2 left-2 flex items-center text-gray-400"
                  />
                </div>
              </label>
            </h6>
            <div className="flex items-center  gap-3">
              <div className="w-full  sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>
            </div>
            <div className="shrink-0"></div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${
                    sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                  }`}
            </div>
          )}
          {data?.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={12}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-auto"
              tableclassName="w-full whitespace-nowrap overflow-auto"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={isLoading ? 10 : 0}
              text={isLoading ? "در حال بارگذاری..." : " داده ای وجود  ندارد"}
            />
          )}
        </div>
      </div>
      <div className="mb-2">
        <PaginationTest
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

      <Modal
        show={showModalDELever}
        onHide={handclosemodal}
        className="fixed inset-0 flex items-center justify-center z-[9999] bg-black/30 backdrop-blur-sm"
        dialogClassName="relative w-full max-w-md bg-white dark:bg-zink-700 rounded-xl shadow-xl mx-4 my-8 overflow-hidden border border-amber-100 dark:border-zink-600"
      >
        {/* Header */}
        <Modal.Header className="flex items-center justify-between p-5 border-b border-amber-200 dark:border-zink-600 bg-amber-50 dark:bg-zink-800">
          <Modal.Title className="text-xl font-bold text-amber-800 dark:text-amber-200 flex items-center gap-2">
            <Package className="w-5 h-5" />
            تحویل تفاله
          </Modal.Title>
        </Modal.Header>

        {/* Body */}
        <Modal.Body className="p-6 overflow-y-auto max-h-[70vh] bg-white dark:bg-zink-700">
          <div className="flex flex-col md:flex-row w-full justify-center gap-4">
            {/* تحویل تفاله Button */}
            <button
              className="flex-1 flex flex-col items-center justify-center p-6 transition-all duration-300 ease-in-out rounded-xl 
                      bg-gradient-to-br from-amber-400 to-amber-600 hover:from-amber-500 hover:to-amber-700
                      text-white font-bold text-lg shadow-md hover:shadow-lg
                      focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2"
              onClick={deleverywasteModal}
            >
              <Package className="w-8 h-8 mb-2" strokeWidth={1.5} />
              تحویل تفاله
            </button>

            {/* واریز هزینه تفاله Button */}
            <button
              className="flex-1 flex flex-col items-center justify-center p-6 transition-all duration-300 ease-in-out rounded-xl 
                      bg-gradient-to-br from-green-400 to-green-600 hover:from-green-500 hover:to-green-700
                      text-white font-bold text-lg shadow-md hover:shadow-lg
                      focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
              onClick={PaywasteModal}
            >
              <CreditCard className="w-8 h-8 mb-2" strokeWidth={1.5} />
              واریز هزینه تفاله
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Resivewast;
